module.exports = __webpack_public_path__ + "static/media/Argus Filch 2.6dfda9d3.jpg";